import { useState, useEffect } from 'react';
import { MessageCircle } from 'lucide-react';
import { chatAPI } from '../lib/api';
import EnhancedChatDialog from './EnhancedChatDialog';
import { devError } from '../lib/devLog';

const ChatButton = ({ recipientId, recipientName }) => {
  const [unreadCount, setUnreadCount] = useState(0);
  const [showChat, setShowChat] = useState(false);

  useEffect(() => {
    fetchUnreadCount();
    const interval = setInterval(fetchUnreadCount, 10000);
    return () => clearInterval(interval);
  }, []);

  const fetchUnreadCount = async () => {
    try {
      const res = await chatAPI.getUnreadCount();
      setUnreadCount(res.data.unread_count);
    } catch (error) {
      devError('Failed to fetch unread count:', error);
    }
  };

  return (
    <>
      <button
        onClick={() => setShowChat(true)}
        className="relative p-2 rounded-full hover:bg-zinc-100 transition-colors"
        data-testid="chat-button"
      >
        <MessageCircle className="w-5 h-5 text-zinc-600" />
        {unreadCount > 0 && (
          <span className="absolute -top-0.5 -right-0.5 w-5 h-5 bg-orange-500 text-white text-xs font-bold rounded-full flex items-center justify-center">
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        )}
      </button>

      <EnhancedChatDialog
        open={showChat}
        onOpenChange={setShowChat}
        recipientId={recipientId}
        recipientName={recipientName}
      />
    </>
  );
};

export default ChatButton;
